import { Link } from "react-router-dom";
import { ChevronRight, Fuel, IndianRupee, Wallet } from "lucide-react";
import { FeatureHeader } from "./shared";
import "../../styles/allowances-benefits.css";

const FEATURES = [
  {
    to: "/settings/allowances-benefits/fuel-reimbursement",
    icon: Fuel,
    title: "Fuel Reimbursement",
    description:
      "Mark employees eligible, collect petrol bills, approve reimbursements, and pay approved amounts in payroll.",
  },
  {
    to: "/settings/allowances-benefits/advance-taken",
    icon: IndianRupee,
    title: "Advance Taken",
    description:
      "Record salary advances, approve before deduction, and track recovery history across payroll runs.",
  },
];

export default function AllowancesBenefitsHub() {
  return (
    <div className="ab-page">
      <FeatureHeader
        icon={Wallet}
        title="Allowances & Benefits"
        subtitle="Central place to manage fuel reimbursement and salary advances for your organisation."
        breadcrumb={
          <>
            <Link to="/settings">Settings</Link>
            <span>/</span>
            <span>Allowances & Benefits</span>
          </>
        }
      />

      <div className="ab-hub">
        {FEATURES.map((feature) => {
          const Icon = feature.icon;
          return (
            <Link key={feature.to} to={feature.to} className="ab-hub-card">
              <span className="ab-hub-card__icon" aria-hidden>
                <Icon size={22} strokeWidth={2} />
              </span>
              <h2>{feature.title}</h2>
              <p>{feature.description}</p>
              <span className="ab-hub-card__cta">
                Open <ChevronRight size={14} style={{ display: "inline", verticalAlign: "middle" }} />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
